<div *ngIf="showProgressBar$ | async">
    <app-upload-progress [title]="progressBarTitle"></app-upload-progress>
</div>

<iframe
    class="formular-iframe"
    #iframeformular
    [src]="formularLink | safeFormularUrl"
    title="Formular"></iframe>
